import { IMessage } from "react-native-gifted-chat";
import api from "../api";

export interface Message extends IMessage { }

class MessageService {
  async getMessages(bookingId: number): Promise<Message[]> {
    const response = await api.get(`/messages/booking/${bookingId}`);
    return response.data.data;
  }

  async sendMessage(data: {
    booking_id: number;
    receiver_id: number;
    message: string;
  }): Promise<Message> {
    const response = await api.post("/messages", data);
    return response.data.data;
  }

  async markAsRead(messageId: number | string): Promise<void> {
    await api.put(`/messages/${messageId}/read`);
  }
}

export default new MessageService();
